<template>
  <div
    v-if="active === true"
    class="loading-container"
    :class="{ 'full-height': fullHeight }"
  >
    <LoadingRing />

    <div v-if="text" v-html="text" class="text"></div>
  </div>
</template>

<script>
import LoadingRing from './LoadingRing.vue'

export default {
  name: 'Loading',

  components: {
    LoadingRing,
  },

  props: {
    active: {
      type: Boolean,
      required: false,
      default: true,
    },

    fullHeight: {
      type: Boolean,
      required: false,
      default: true,
    },

    text: {
      type: [String, Boolean],
      required: false,
      // default: 'Carregando...',
    },

    size: {
      type: Number,
      required: false,
      default: 50,
    },
  },
}
</script>

<style lang="scss" scoped>
.loading-container {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  &.no-margin-top {
    margin-top: 0;
  }
}

.text {
  text-align: center;
  margin-top: 0.5rem;
}
</style>
